// File: frontend/src/components/songEdit/forms/ComposerForm.tsx
import React, { useState, useEffect } from 'react';
import { Person } from '../types/composerTypes';

interface ComposerFormProps {
  type: 'composer' | 'lyricist' | 'arranger';
  initialPerson: Person;
  onSubmit: (person: Person) => void;
  onClose: () => void;
}

export const ComposerForm: React.FC<ComposerFormProps> = ({
  type,
  initialPerson,
  onSubmit,
  onClose
}) => {
  const [formData, setFormData] = useState<Person>(initialPerson);

  // Keep local state in sync with prop changes
  useEffect(() => {
    setFormData(initialPerson);
  }, [initialPerson]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('[ComposerForm] Submitting person:', formData);
    onSubmit(formData);
  };

  return (
    <div className="border rounded p-4 mt-2 bg-gray-50">
      <form onSubmit={handleSubmit}>
        <h4 className="mb-3">Add New {type.charAt(0).toUpperCase() + type.slice(1)}</h4>
        
        <div className="mb-3">
          <label className="form-label">Full Name *</label>
          <input
            type="text"
            className="form-control"
            name="full_name"
            value={formData.full_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Era</label>
              <input
                type="text"
                className="form-control"
                name="era"
                value={formData.era || ''}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Origin</label>
              <input
                type="text"
                className="form-control"
                name="origin"
                value={formData.origin || ''}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Additional Information</label>
          <textarea
            className="form-control"
            name="additional_info"
            value={formData.additional_info || ''}
            onChange={handleChange}
            rows={3}
          />
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button 
            type="submit"
            className="btn btn-primary"
            disabled={!formData.full_name}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};